<template>
  <div class="public-shop">
    <header class="shop-header" :style="{ background: themeGradient }">
      <div class="container py-3">
        <router-link :to="shopPath('')" class="header-link">
          <i class="fas fa-arrow-left"></i> Kembali ke Toko
        </router-link>
      </div>
    </header>

    <div class="container mt-4 pb-5">
      <div v-if="loading" class="text-center p-5">
        <div class="spinner-border text-primary"></div>
        <p class="text-muted mt-3">Memuat katalog kursus...</p>
      </div>

      <template v-else>
        <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
          <h2 class="page-title mb-2 mb-md-0"><i class="fas fa-graduation-cap text-primary"></i> Katalog Kursus</h2>
          <span class="text-muted">{{ courses.length }} kursus tersedia</span>
        </div>

        <div v-if="courses.length === 0" class="empty-state">
          <i class="fas fa-book-open empty-state-icon"></i>
          <h4>Belum ada kursus</h4>
          <p class="text-muted">Toko ini sedang menyiapkan materi belajar. Cek lagi nanti!</p>
          <router-link :to="shopPath('')" class="btn btn-light mt-2">Kembali ke Toko</router-link>
        </div>

        <div v-else class="row">
          <div v-for="course in courses" :key="course.id" class="col-lg-4 col-md-6 mb-4">
            <div class="product-card h-100" style="cursor:pointer" @click="goCourse(course.slug)">
              <div class="card-img-wrap">
                <img :src="courseImage(course.cover_image_url)" :alt="course.title">
              </div>
              <div class="card-body p-3">
                <h5 class="course-title">{{ course.title }}</h5>
                <p class="text-muted small mb-2" v-if="course.description">{{ truncate(course.description, 90) }}</p>
                <div class="d-flex justify-content-between align-items-center">
                  <b :class="course.is_free ? 'text-success' : 'text-primary'">
                    {{ course.is_free ? 'GRATIS' : formatRupiah(course.price) }}
                  </b>
                  <small class="text-muted"><i class="fas fa-users"></i> {{ course.enrollment_count || 0 }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import publicShopPaths from './public_shop_paths';
import { applyShopTheme, shopHeaderBackground, courseImage, shopPublicMixin } from '@/components/shop_public/shop_public_utils';
import { trackPageView, trackViewCategory } from '@/components/shop_public/shop_tracking';
import '@/components/shop_public/shop_public.css';

export default {
  mixins: [publicShopPaths, shopPublicMixin],
  data() {
    return { loading: true, courses: [], shop: null };
  },
  computed: {
    themeGradient() {
      return shopHeaderBackground(this.shop);
    },
  },
  mounted() { this.load(); },
  methods: {
    courseImage,
    truncate(s, n) { return s && s.length > n ? s.slice(0, n) + '...' : s; },
    goCourse(slug) {
      this.$router.push(this.shopPath('/kursus/' + slug));
    },
    async load() {
      try {
        if (!this.effectiveSlug && this.onCustomDomain) {
          await this.$store.dispatch('public_shop/public_get_shop_by_domain');
        }
        const rShop = await this.$store.dispatch('public_shop/public_get_shop', this.effectiveSlug);
        this.shop = rShop.data.data.shop;
        applyShopTheme(this.shop);
        trackPageView({ page_type: 'course_catalog' });
        trackViewCategory('Kursus Online', 'courses');
        const r = await this.$store.dispatch('public_shop/public_get_lms_courses', this.effectiveSlug);
        this.courses = r.data.data.courses || [];
      } catch (e) {
        this.courses = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.page-title {
  font-weight: 600;
}
.course-title {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
}
</style>
